import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['element']

  disable() {
    this.elementTargets.forEach((e) => {
      $(e).prop('disabled', function (i, v) { return !v })
    })
  }
}
